import { render, staticRenderFns } from "./CenterMainContent.vue?vue&type=template&id=567ecaaf"
import script from "./CenterMainContent.vue?vue&type=script&lang=js"
export * from "./CenterMainContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports